import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import styles from './Settings.module.scss';
import ArrowDown from '../../assets/caret-down-fill.svg';
import ArrowUp from '../../assets/caret-up-fill.svg';
import BlackListIcon from '../../assets/ban.svg';
import ListItem from "./ListItem";
import { useAppSelector } from "../../hooks/hook";
import DialogComponent, { LayoutDialogList } from "./DialogComponent";
import { useTranslation } from "react-i18next";
import { Virtuoso } from "react-virtuoso";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
export function EmptyList() {
    const { t } = useTypedTranslation();
    return (_jsxs("div", { className: styles['empty-container'], children: [_jsx("div", { className: styles['empty-icon'], children: "\uD83D\uDCC2" }), _jsx("p", { className: styles['empty-text'], children: t('emptyList') })] }));
}
function List(props) {
    const { list, currentUserEmail } = props;
    if (list.length === 0)
        return _jsx(EmptyList, {});
    return (_jsx(LayoutDialogList, { children: _jsx(Virtuoso, { style: { height: '100%' }, data: list, totalCount: list.length, itemContent: (index, item) => (_jsx(ListItem, { user: item, currentUserEmail: currentUserEmail }, item.uid)) }) }));
}
const BlackList = () => {
    const [open, setOpen] = useState(false);
    const list = useAppSelector(state => state.app.blackList);
    const currentUserEmail = useAppSelector(state => state.app.currentUser.email);
    const { t } = useTranslation();
    return (_jsxs("div", { className: styles.item, children: [_jsxs("div", { className: styles.container, children: [_jsx("div", { children: _jsx(BlackListIcon, {}) }), _jsxs("div", { className: styles.containerItem, onClick: () => setOpen(() => !open), children: [_jsx("div", { children: _jsx("span", { style: { cursor: 'pointer' }, children: t('darkList') }) }), open ?
                                _jsx(ArrowUp, { cursor: 'pointer' })
                                :
                                    _jsx(ArrowDown, { cursor: 'pointer' })] })] }), _jsx("div", { className: styles.dropDawnContainer, children: _jsx(DialogComponent, { isOpen: open, onClose: setOpen, children: _jsx(List, { list: list, currentUserEmail: currentUserEmail }) }) })] }));
};
export default BlackList;
